<template>
  <transition name="modal">
    <div class="ui-modal overlay component" v-if="show" @click="onClickOverlay" ref="overlay">
      <div class="modal-content">
        <div class="header">
          <div class="close" @click="close" v-if="showCloseButton">
            <div class="close-line left"></div>
            <div class="close-line right"></div>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'UiModal',

    props: {
      show: {
        type: Boolean,
        default: false
      },
      showCloseButton: {
        type: Boolean,
        default: true
      },
      closeOnOverlay: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      close () {
        this.$emit('update:show', false)
      },
      onClickOverlay ($event) {
        if (this.closeOnOverlay && $event && $event.target === this.$refs.overlay) {
          this.close()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ui-modal.overlay.component {
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal-content {
      width: 100%;
      height: 100%;
      background-color: $white;
      box-shadow: 0 7px 20px rgba(0, 0, 0, 0.5);
      .header {
        display: flex;
        justify-content: flex-end;
        .close {
          cursor: pointer;
          position: absolute;
          width: 42px;
          height: 42px;
          right: 20px;
          top: 20px;

          .close-line {
            display: block;
            width: 100%;
            height: 4px;
            background-color: $dark-color;
            position: relative;

            &:before {
              content: "";
              position: absolute;
              top: 10px;
              left: 0;
              display: block;
              width: 0;
              height: 100%;
              background-color: $white;
              transition: $slide;
            }

            &.left {
              transform: rotate(-45deg);
            }

            &.right {
              transform: rotate(45deg);
              top: -3px;
            }
          }
        }
      }
    }
  }

  /* modal transition */
  .modal-enter-active, .modal-leave-active {
    transition: all .3s ease;
  }
  .modal-enter, .modal-leave-to {
    padding-top: 100px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UiModal.vue